import React from 'react'

const Empty = () => (
  <div className='pt-3 pb-1'>
    <p className='txt-body-sm txt-center'>
      Nenhum registro encontrado no período
    </p>
  </div>
)

export default Empty



// WEBPACK FOOTER //
// ./src/Participant/Extract/Details/Empty.js